import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {NavLink} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {DeleteConfirme} from "../DeleteConfirme";
import {album} from "../../../models/album";
import {scrollTo} from "../../../service/ToolsService";

type AlbumListProp = {
  albums: album[],
  loading?: boolean,
  refresh: () => void,
}

export const AlbumList = ({albums, loading, refresh}: AlbumListProp) => {
  const [del, setDel] = useState(undefined as undefined | album);

  const deleteAlbum = async (album: album) => {
    await ApiService.delete(`/album/${album.albumId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th className="w80px">Couverture</th>
          <th>Nom</th>
          <th className="text-center w80px">Photos</th>
          <th className="text-center w80px">Visible</th>
          <th className="text-center w150px d-lg-table-cell d-none">Modification</th>
          <th className="w190px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={6} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && albums.length === 0 && (
          <tr>
            <td colSpan={6} className="text-center text-muted p-4">Aucun album pour le moment.</td>
          </tr>
        )}

        {!loading && albums.map((a: album, i: number) => (
          <tr key={i} className="align-middle">
            <td>
              {a.cover
                ? <img src={a.cover} alt={a.label} className="__admin_album_cover__"
                       title={a.src ? undefined : 'Première photo (aucune couverture choisie)'}/>
                : <div className="__admin_album_cover__ __admin_album_cover_empty__"><i className="fa-regular fa-image"/></div>
              }
            </td>
            <td>{a.label}</td>
            <td className="text-center">
              <span className={`badge ${a.photoCount > 0 ? 'bg-primary' : 'bg-warning'}`}>{a.photoCount}</span>
            </td>
            <td className="text-center">{a.enabled && (<i className="fa-solid fa-eye"/>)}</td>
            <td className="text-center d-lg-table-cell d-none">
              {DateService
                .toLocaleString(a.updatedAt ?? a.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/album/edit/${a.albumId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(a)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      {del && (
        <DeleteConfirme
          message={del.photoCount > 0
            ? `L'album « ${del.label} » et ses ${del.photoCount} photo${del.photoCount > 1 ? 's' : ''} seront supprimés définitivement. Continuer ?`
            : undefined}
          confirme={(c: boolean) => {
            if (c) {
              deleteAlbum(del);
            }

            setDel(undefined);
          }}/>
      )}
    </>
  );
}
